<template>
	<header>
		<nav class="main-menu" id="menu">
			<div class="header__logo">
				<a v-if="user.organization.picture" href="/" :style="{ backgroundImage: 'url(' + user.organization.picture + ')' }">
					{{ user.organization.name }}
				</a>
				<a v-else href="/">
					{{ user.organization.name }}
				</a>
			</div>
			<div class="header__items">
				<!--
				@TK temporarily remove menu toggle, it should come back
				after bugs with it's small/big images have been solved
				<label for="menu-controller"></label>
				-->
				<ul class="notifications" v-if="notifications">
					<li
						v-for="(notification) in notifications"
						:key="notification.id"
					>
						<router-link
							:to="notification.link"
							:class="notification.icon"
						>
							{{notification.text}}
							<label
								v-if="notification.is_count === 0"
								:class="notification.label ? notification.label : ''">
								<template v-if="notification.is_time">
									{{ notification.message | parseMinutes }}
								</template>
								<template v-else>
									{{ notification.message }}
								</template>
							</label>
							<label v-else-if="notification.count > 0">
								{{notification.count}}
							</label>
						</router-link>
					</li>
				</ul>
			</div>
		</nav>
	</header>
</template>
<script>
const images = require.context('../../images', false, /\.(png|jpg|gif|svg)$/);

export default {
	name: 'myHeader',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		notifications() {
			return this.$store.state.notifications.notifications;
		},
	},
	beforeCreate() {
		const session = {
			apiKey: sessionStorage.getItem('apiKey'),
			userId: sessionStorage.getItem('userId'),
		};
		if (!session.apiKey) {
			this.$router.push('/');
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('signOut');
			this.$router.push('/');
		},
		imgUrl(path) {
			return images(`./${path}`);
		},
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/components/header.vue